export const INITIAL_STATE = {
    name: null,
    is_allow_multiple: false,
    items: [],
}

export const GET_FIELD_NAME = {
    name: 'Title beauty profile',
    items: 'Beauty profile item',
}

export const GET_ITEM_FIELD_NAME = {
    name: 'Label beauty profile',
    image_url: 'Icon beauty profile',
}

export const FIELD_NAME_DETAIL = {
    ...GET_FIELD_NAME,
    is_allow_multiple: 'Allow multiple select beauty profile',
}
